export function MetaIntegrationTerms() {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <h1 className="text-3xl font-bold heading">Termos de Uso - Integração Meta (Instagram/Facebook)</h1>

      <div className="text-sm text-dim">
        Última atualização: 24 de outubro de 2025
      </div>

      <div className="prose prose-invert max-w-none space-y-6" style={{ color: 'var(--cg-text)' }}>
        <section>
          <h2 className="text-xl font-semibold heading mb-3">1. Aceitação dos Termos</h2>
          <p>
            Ao ativar o Modo Avançado de Publicação Automática do CopyGenius, você concorda em vincular suas contas Instagram Business e/ou Páginas do Facebook ao nosso serviço para publicação automatizada de conteúdo gerado por IA.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold heading mb-3">2. Requisitos das Contas</h2>
          <p><strong>Instagram:</strong></p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Conta Instagram Business ou Creator</li>
            <li>Vinculada a uma Página do Facebook</li>
            <li>Permissões de administrador</li>
          </ul>
          <p className="mt-3"><strong>Facebook:</strong></p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Página do Facebook (não perfil pessoal)</li>
            <li>Permissões de administrador</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold heading mb-3">3. Permissões e Autorização</h2>
          <p>
            Ao conectar suas contas, você autoriza o CopyGenius a:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Publicar conteúdo (texto e imagens) em seu nome</li>
            <li>Acessar informações básicas da conta (nome, foto, @username)</li>
            <li>Gerenciar posts criados pelo aplicativo</li>
          </ul>
          <p className="mt-3">
            <strong>O CopyGenius NÃO irá:</strong>
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Publicar conteúdo sem sua ação explícita</li>
            <li>Acessar mensagens privadas ou dados sensíveis</li>
            <li>Compartilhar seus tokens de acesso com terceiros</li>
            <li>Vender ou monetizar seus dados</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold heading mb-3">4. Limitações da API Meta</h2>
          <p>
            As seguintes limitações são impostas pela API do Instagram/Facebook:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Máximo de 25 publicações no Instagram por dia</li>
            <li>Apenas imagens JPEG são suportadas</li>
            <li>Stories não podem ser publicadas via API</li>
            <li>Filtros e efeitos não são suportados</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold heading mb-3">5. Responsabilidade do Usuário</h2>
          <p>
            Você é responsável por:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Revisar todo conteúdo antes de publicar</li>
            <li>Garantir que o conteúdo está em conformidade com os Termos de Uso do Instagram e Facebook</li>
            <li>Respeitar direitos autorais e propriedade intelectual</li>
            <li>Manter a segurança de sua conta Meta</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold heading mb-3">6. Revogação de Acesso</h2>
          <p>
            Você pode desconectar suas contas a qualquer momento através das Configurações do CopyGenius ou diretamente nas configurações de privacidade do Facebook/Instagram. A revogação é instantânea e os tokens de acesso são imediatamente invalidados.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold heading mb-3">7. Segurança dos Dados</h2>
          <p>
            Todos os tokens de acesso são criptografados (AES-256) e armazenados com segurança. Implementamos as melhores práticas de segurança recomendadas pela Meta para proteger suas credenciais.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold heading mb-3">8. Modificações e Descontinuação</h2>
          <p>
            Reservamos o direito de modificar ou descontinuar a integração com Meta a qualquer momento. Você será notificado com antecedência razoável sobre mudanças significativas.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold heading mb-3">9. Conformidade LGPD</h2>
          <p>
            Esta integração está em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018). Você tem direito de:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Confirmar a existência de tratamento de dados</li>
            <li>Acessar seus dados</li>
            <li>Solicitar correção de dados incompletos ou imprecisos</li>
            <li>Solicitar exclusão de dados</li>
            <li>Revogar consentimento a qualquer momento</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold heading mb-3">10. Contato</h2>
          <p>
            Para questões sobre estes termos ou sobre a integração Meta, entre em contato através de: <a href="mailto:suporte@copygenius.com" className="text-accent">suporte@copygenius.com</a>
          </p>
        </section>

        <div className="p-4 rounded-lg border-2 mt-8" style={{
          backgroundColor: 'var(--cg-accent-soft)',
          borderColor: 'var(--cg-accent)'
        }}>
          <p className="font-semibold">
            <i className="fa-solid fa-triangle-exclamation mr-1"></i> Importante: Ao aceitar estes termos, você confirma ter lido, compreendido e concordado com todas as disposições acima.
          </p>
        </div>
      </div>
    </div>
  );
}
